// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tvfH","question":"styles_question__3dXUF","description":"styles_description__3L5DY"};